import { S } from "../theme";

function Logo({ size = 1.2 }) {
  return (
    <span style={{ fontFamily: "'Fraunces', serif", fontWeight: 900, fontSize: `${size}rem`, letterSpacing: "-0.02em", color: S.ink }}>
      Track<span style={{ color: S.accent }}>My</span>Peptide
    </span>
  );
}

function Pill({ children, color = S.accent, bg = S.accentLight }) {
  return (
    <span style={{ background: bg, color, fontSize: "0.68rem", fontWeight: 700, letterSpacing: "0.06em", padding: "4px 10px", borderRadius: 100, border: `1px solid ${color}33`, display: "inline-block" }}>
      {children}
    </span>
  );
}

function Card({ children, style = {}, onClick }) {
  return (
    <div onClick={onClick} style={{ background: S.white, border: `1px solid ${S.border}`, borderRadius: 20, padding: 28, transition: "all 0.2s", cursor: onClick ? "pointer" : "default", ...style }}>
      {children}
    </div>
  );
}

function BtnPrimary({ children, onClick, style = {}, disabled }) {
  return (
    <button disabled={disabled} onClick={onClick} style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "0.9rem", color: "#fff", background: disabled ? "#aaa" : S.accent, border: "none", padding: "14px 28px", borderRadius: 100, cursor: disabled ? "not-allowed" : "pointer", transition: "all 0.2s", boxShadow: disabled ? "none" : "0 4px 16px rgba(45,106,79,0.25)", ...style }}>
      {children}
    </button>
  );
}

function BtnGhost({ children, onClick, style = {} }) {
  return (
    <button onClick={onClick} style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: "0.88rem", color: S.ink2, background: "transparent", border: `1.5px solid ${S.border}`, padding: "12px 22px", borderRadius: 100, cursor: "pointer", transition: "all 0.2s", ...style }}>
      {children}
    </button>
  );
}

function Input({ label, type = "text", value, onChange, placeholder, style = {} }) {
  return (
    <div style={{ marginBottom: 16 }}>
      {label && <label style={{ display: "block", fontSize: "0.78rem", fontWeight: 600, color: S.ink2, marginBottom: 6 }}>{label}</label>}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{ width: "100%", padding: "12px 16px", border: `1.5px solid ${S.border}`, borderRadius: 12, fontSize: "0.9rem", fontFamily: "'Inter', sans-serif", background: S.bg, color: S.ink, outline: "none", boxSizing: "border-box", ...style }}
      />
    </div>
  );
}

function Select({ label, value, onChange, options }) {
  return (
    <div style={{ marginBottom: 16 }}>
      {label && <label style={{ display: "block", fontSize: "0.78rem", fontWeight: 600, color: S.ink2, marginBottom: 6 }}>{label}</label>}
      <select
        value={value}
        onChange={onChange}
        style={{ width: "100%", padding: "12px 16px", border: `1.5px solid ${S.border}`, borderRadius: 12, fontSize: "0.9rem", fontFamily: "'Inter', sans-serif", background: S.bg, color: S.ink, outline: "none" }}
      >
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}

// ─── READ-ONLY GATE ─────────────────────────────────────────
// Returns true if the user should be in read-only mode (expired trial, no subscription)

export { Logo, Pill, Card, BtnPrimary, BtnGhost, Input, Select };
